<template>
  <div class="page">

    <!-- Page Header -->
    <div class="page-head">
      <div>
        <h1>Notifications</h1>
        <p>System alerts, updates, and activity logs</p>
      </div>

      <button class="btn ghost" @click="load">
        <i class="bx bx-refresh"></i>
        Refresh
      </button>
    </div>

    <!-- Notifications Card -->
    <div class="card noti-card">

      <!-- Header Row -->
      <div class="noti-head">
        <strong>All Notifications</strong>

        <span v-if="unread>0" class="badge primary">
          {{ unread }} unread
        </span>
      </div>

      <!-- Loading -->
      <div v-if="loading" class="noti-state">
        <div class="skeleton" style="width:80%"></div>
        <div class="skeleton" style="width:60%"></div>
        <div class="skeleton" style="width:70%"></div>
      </div>

      <!-- Empty -->
      <div v-else-if="list.length==0" class="noti-empty">
        <i class="bx bx-bell-off"></i>
        <div>No notifications found</div>
      </div>

      <!-- List -->
      <div v-else class="noti-items">

        <div
          v-for="n in list"
          :key="n.notification_id"
          class="noti-item"
          :class="{ unread: n.noti_type=='1' }"
          @click="open(n)"
        >

          <div class="noti-dot" v-if="n.noti_type=='1'"></div>

          <div class="noti-body">
            <div class="noti-title">{{ n.title }}</div>
            <div class="noti-desc">{{ n.desc }}</div>
            <div class="noti-time">{{ n.datetime }}</div>
          </div>

          <i class="bx bx-chevron-right"></i>

        </div>

      </div>

    </div>

  </div>
</template>


<script>
import { getNotifications, markRead, unreadCount } from "@/apis/notification";

export default {
  name:"AdminNotificationList",

  data(){
    return{
      list:[],
      unread:0,
      loading:true,
      admin_id: ""
    }
  },

  mounted(){
    const raw = sessionStorage.getItem("ldata");
    const ldata = JSON.parse(raw);
    this.admin_id = ldata.user_id || "";
    this.load();
    this.poll();
  },

  methods:{
    async load(){
      this.loading=true;
      const res = await getNotifications(this.admin_id);
      if(res.status){
        this.list = res.records;
      }
      this.loading=false;
      this.loadUnread();
    },

    async loadUnread(){
      const res = await unreadCount(this.admin_id);
      if(res.status){
        this.unread = res.unread;
      }
    },

    async open(n){
      if(n.noti_type=="1"){
        await markRead(n.notification_id);
        n.noti_type="0";
        this.unread--;
      }

      // Optional routing
      // this.$router.push("/users/"+n.noti_ref);
    },

    poll(){
      setInterval(()=>{
        this.loadUnread();
      },5000);
    }
  }
}
</script>

<style scoped>
/* Card wrapper */
.noti-card{
  padding:0;
}

/* Top row inside card */
.noti-head{
  padding:16px 18px;
  display:flex;
  align-items:center;
  justify-content:space-between;
  border-bottom:1px solid var(--line);
}

.noti-head strong{
  font-size:14px;
  font-weight:var(--w-bold);
}

/* States */
.noti-state,
.noti-empty{
  padding:40px 18px;
  display:grid;
  gap:14px;
  place-items:center;
  text-align:center;
  color:var(--muted);
  font-size:13px;
}

.noti-empty i{
  font-size:30px;
  color:var(--primary);
}

/* List */
.noti-items{
  max-height: calc(100vh - 260px);
  overflow-y:auto;
}

/* Item */
.noti-item{
  display:flex;
  gap:14px;
  padding:16px 18px;
  align-items:flex-start;
  cursor:pointer;
  border-bottom:1px solid rgba(241,245,249,.95);
  transition:200ms ease;
}

.noti-item:hover{
  background: rgba(46,109,231,.05);
}

.noti-item.unread{
  background: var(--primary-10);
}

/* unread dot */
.noti-dot{
  height:8px;
  width:8px;
  border-radius:50%;
  background:var(--primary);
  margin-top:7px;
  flex-shrink:0;
}

/* Body */
.noti-body{
  flex:1;
}

.noti-title{
  font-size:13px;
  font-weight:var(--w-semibold);
}

.noti-desc{
  margin-top:4px;
  font-size:12px;
  color:var(--muted);
  line-height:1.45;
}

.noti-time{
  margin-top:6px;
  font-size:11px;
  color:rgba(100,116,139,.85);
  font-weight:var(--w-medium);
}

/* Arrow */
.noti-item i{
  font-size:18px;
  color:rgba(100,116,139,.85);
  margin-top:2px;
}

/* Mobile */
@media(max-width:760px){
  .noti-items{
    max-height: unset;
  }

  .noti-item{
    padding:14px;
  }
}

</style>
